module.exports = __webpack_public_path__ + "static/media/41.c0404268.jpg";